export const COMPONENT_NAME = "kyb-participant";
